import { Component, Input }        from '@angular/core';
import { TableService }     from '../../table/table.service';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CriticalMessageModel }    from './typings/critical-message';
import { CriticalMessagesService } from './critical-messages.service';
import { MessagesService }         from '../messages.service';
import { Table }                   from '../../table/types/table';
import { TableQueryParameters }    from '../../table/types/table-query-parameters';
import { CriticalMessagesActionsComponent } from './critical-messages.actions.component';

@Component({
  selector   : 'wor-critical-messages',
  template: require('./critical-messages.component.html')
})
export class CriticalMessagesComponent {
  private criticalMessagesTableCacheKey = 'criticalMessages';

  public tableSettings : Table = {
    cache: {
      enabled: true,
      key    : this.criticalMessagesTableCacheKey
    },
    columns: [
      {
        field : 'title',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TITLE')
        }
      },
      {
        field : 'body',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.MESSAGE.MESSAGE')
        }
      },
      {
        field : 'status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'properCase'
      },
      {
        component: {
          bindings: {
            outputs: {
              onVerifyClick: ( row : CriticalMessageModel ) => this.verifyCriticalMessage(row)
            }
          },
          enabled: true,
          factory: CriticalMessagesActionsComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CRITICAL_MESSAGES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.criticalMessagesTableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => this.criticalMessagesService.getCount()
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  @Input() messages : Array<CriticalMessageModel>;

  constructor (
    private criticalMessagesService: CriticalMessagesService,
    private messagesService        : MessagesService,
    private router                 : UIRouter,
    private tableService           : TableService,
    private translateService       : TranslateService
  ) {}

  createCriticalMessage () : void {
    this.criticalMessagesService.create()
    .then(() => this.router.stateService.reload())
    .catch(error => this.messagesService.error(error));
  }

  getCriticalMessages ( params : TableQueryParameters ) : Promise<Array<CriticalMessageModel>> {
    return this.criticalMessagesService.get(params)
    .then(( messages : Array<CriticalMessageModel> ) => {
      this.messages = messages;

      return messages;
    });
  }

  verifyCriticalMessage ( message : CriticalMessageModel ) : void {
    this.criticalMessagesService.verify(message)
    .then(() => this.router.stateService.reload())
    .catch(error => this.messagesService.error(error));
  };
}